import React, { useState } from "react";
import { validateLoggedIn, getSession } from "../utils";
import {
    TextField,
    Button,
    Paper,
    Typography,
    Box,
    MenuItem,
} from "@mui/material";
import NavBar from "../navbar";
import { useNavigate } from "react-router-dom";
import config from "../config";
import * as Sentry from "@sentry/react";

const CreateUser = () => {
    const navigate = useNavigate();

    const [userData, setUserData] = useState({
        login: "",
        role: "member",
        password: "",
        email: "",
        name: "",
    });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const validate_logged_in = validateLoggedIn();
    if (validate_logged_in) {
        return validate_logged_in;
    }

    const handleChange = (field, value) => {
        setUserData({ ...userData, [field]: value });
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const response = await fetch(config.apiBaseUrl + "/admin/users", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "user-authorization": getSession().token,
                },
                body: JSON.stringify(userData),
            });
            if (response.status === 409) {
                throw new Error("User already exists");
            }
            if (!response.ok) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }
            alert("User created successfully!");
            navigate(`/users`);
        } catch (err) {
            Sentry.captureException(err);
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <NavBar />
            <Box sx={{ maxWidth: 600, margin: "auto", padding: 3 }}>
                <Paper sx={{ padding: 3 }}>
                    <Typography variant="h5" gutterBottom>
                        Create User
                    </Typography>
                    {error && (
                        <Typography variant="body2" color="error" gutterBottom>
                            {error}
                        </Typography>
                    )}
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Login"
                        value={userData.login}
                        onChange={(e) => handleChange("login", e.target.value)}
                    />
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        label="Role"
                        value={userData.role}
                        onChange={(e) => handleChange("role", e.target.value)}
                    >
                        <MenuItem value="member">Member</MenuItem>
                        <MenuItem value="admin">Admin</MenuItem>
                    </TextField>
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Password"
                        type="password"
                        value={userData.password}
                        onChange={(e) => handleChange("password", e.target.value)}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Email"
                        value={userData.email}
                        onChange={(e) => handleChange("email", e.target.value)}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Name"
                        value={userData.name}
                        onChange={(e) => handleChange("name", e.target.value)}
                    />
                    <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {saving ? "Saving..." : "Save"}
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => navigate(`/users`)}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Paper>
            </Box>
        </>
    );
};

export default CreateUser;
